// ✅ src/components/BottomNav.js
import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function BottomNav() {
  const nav = useNavigate();
  const location = useLocation();

  const activeKey = useMemo(() => {
    const p = location.pathname || "/";

    if (p.startsWith("/chats") || p.startsWith("/chat/")) return "messages";
    if (p.startsWith("/likes")) return "likes";
    if (p.startsWith("/matches")) return "matches";
    if (p.startsWith("/settings")) return "settings";
    return "home"; // default
  }, [location.pathname]);

  function Tab({ k, label, icon, to }) {
    const isActive = activeKey === k;

    return (
      <button
        type="button"
        onClick={() => nav(to)}
        aria-label={label}
        style={{
          ...S.tab,
          ...(isActive ? S.tabActive : null),
        }}
      >
        <div style={{ ...S.icon, ...(isActive ? S.iconActive : null) }}>{icon}</div>
        <div style={{ ...S.label, ...(isActive ? S.labelActive : null) }}>{label}</div>
      </button>
    );
  }

  return (
    <div style={S.wrap}>
      <div style={S.bar}>
        <Tab k="home" label="Home" icon="🏠" to="/home" />
        <Tab k="messages" label="Messages" icon="💬" to="/chats" />
        <Tab k="likes" label="Likes" icon="💗" to="/likes" />
        <Tab k="matches" label="Matches" icon="💞" to="/matches" />
        <Tab k="settings" label="Settings" icon="⚙️" to="/settings" />
      </div>
    </div>
  );
}

const S = {
  wrap: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999,
    paddingBottom: "env(safe-area-inset-bottom)",
    background:
      "linear-gradient(180deg, rgba(251,250,248,0) 0%, rgba(251,250,248,0.75) 30%, rgba(251,250,248,0.98) 100%)",
    backdropFilter: "blur(10px)",
  },
  bar: {
    width: "min(980px, 100%)",
    margin: "0 auto",
    height: 66,
    borderTop: "1px solid rgba(2,6,23,0.10)",
    background: "rgba(255,255,255,0.85)",
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    alignItems: "center",
    padding: "6px 8px",
  },
  tab: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    display: "grid",
    gap: 2,
    placeItems: "center",
    padding: 8,
    borderRadius: 14,
    userSelect: "none",
  },
  tabActive: {
    background: "rgba(236,72,153,0.10)",
  },
  icon: {
    fontSize: 20,
    lineHeight: 1,
    opacity: 0.78,
    transform: "translateY(0px)",
    transition: "all 160ms ease",
  },
  iconActive: {
    opacity: 1,
    transform: "translateY(-1px)",
  },
  label: {
    fontSize: 11.5,
    fontWeight: 900,
    opacity: 0.65,
    transition: "all 160ms ease",
  },
  labelActive: {
    opacity: 0.95,
  },
};
